import React, { useContext, useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Heading,
  Alert,
  AlertIcon,
  VStack,
} from '@chakra-ui/react';
import UserContext from '../../../context/userContext';
import CustomInput from '../../Common/Input';
import {
  validateEmail,
  validatePhoneNumber,
  validatePassword,
  validateLastName,
  validateName,
} from '../validaciones';

import { crearPostventa } from '../../../services/Admin/crearPostventa';
import { useTranslation } from 'react-i18next';

export default function CrearPostVenta({ isOpen, onClose, loadPostventas }) {
  const { user } = useContext(UserContext);
  const [formData, setFormData] = useState({
    correo: '',
    contrasena: '',
    nombre: '',
    apellidos: '',
    numero: '',
  });

  //input errors usuario
  const [inputErrors, setInputErrors] = useState({
    correo: '',
    contrasena: '',
    nombre: '',
    apellidos: '',
    numero: '',
  });
  

  //errores del back end como correo repetido
  const [errorMsg, setErrorMsg] = useState({ error: false, msg: '' });

  const { t } = useTranslation()

  useEffect(() => {
    setFormData({
      correo: '',
      contrasena: '',
      nombre: '',
      apellidos: '',
      numero: '',
    });
    setInputErrors({
      correo: '',
      contrasena: '',
      nombre: '',
      apellidos: '',
      numero: '',
    });
    setErrorMsg({ error: false, msg: '' });
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrorMsg({ error: false, msg: '' });
    setInputErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const validateForm = () => {
    const phoneNumberValidation = validatePhoneNumber(formData.numero);
    const emailValidation = validateEmail(formData.correo);
    const passwordValidation = validatePassword(formData.contrasena);
    const nameValidation = validateName(formData.nombre);
    const lastnameValidation = validateLastName(formData.apellidos);

    const errors = {
      correo: emailValidation.error ? emailValidation.msg : '',
      contrasena: passwordValidation.error ? passwordValidation.msg : '',
      nombre: nameValidation.error ? nameValidation.msg : '',
      apellidos: lastnameValidation.error ? lastnameValidation.msg : '',
      numero: phoneNumberValidation.error ? phoneNumberValidation.msg : '',
    };

    setInputErrors(errors);
    return Object.values(errors).every((error) => error === '');
  };

  const savePostventa = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      crearPostventa(user.id, formData)
        .then((res) => {
          if (res.status === 200) {
            onClose();
            loadPostventas();
          }
        })
        .catch((err) => {
          //mostrar error estatus 400 y 401
          if (err.response) {
            setErrorMsg({ error: true, msg: err.response.data.error });
          }
        });
    }
  };

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      size={{
        base: 'md',
        md: 'lg',
        xl: 'xl',
      }}
    >
      <ModalOverlay
        bg="blackAlpha.400"
        backdropFilter="blur(5px)"
      />
      <ModalContent>
        <ModalHeader>
          <Heading
            as="h3"
            size={{
              base: 'md', //cambiar a "xl" si se desea mas grande en dispositivos moviles
              md: 'xl',
              xl: 'xl',
            }}
          >
            {t('NEW_POSTSELL_AGENT')}
          </Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={2}>
            <CustomInput
              label={t('EMAIL')}
              type="text"
              name="correo"
              value={formData.correo}
              onChange={handleChange}
              error={inputErrors.correo}
            />

            <CustomInput
              label={t('PASSWORD')}
              type="password"
              name="contrasena"
              value={formData.contrasena}
              onChange={handleChange}
              error={inputErrors.contrasena}
            />

            <CustomInput
              label={t('NAME')}
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              error={inputErrors.nombre}
            />

            <CustomInput
              label={t('LAST_NAME')}
              type="text"
              name="apellidos"
              value={formData.apellidos}
              onChange={handleChange}
              error={inputErrors.apellidos}
            />

            <CustomInput
              label={t('PHONE_NUMBER')}
              type="text"
              name="numero"
              value={formData.numero}
              onChange={handleChange}
              error={inputErrors.numero}
            />
            {errorMsg.error && (
              <Alert status="warning">
                <AlertIcon />
                {errorMsg.msg}
              </Alert>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            variant="ghost"
            onClick={onClose}
          >
            {t('CANCEL')}
          </Button>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={savePostventa}
          >
            {t('SAVE_CHANGES')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
